"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 16 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: 'currentColor',
    d: "M7.41602 9.74996H8.58268V10.9166H7.41602V9.74996ZM7.41602 5.08329H8.58268V8.58329H7.41602V5.08329ZM7.99352 2.16663C4.77352 2.16663 2.16602 4.77996 2.16602 7.99996C2.16602 11.22 4.77352 13.8333 7.99352 13.8333C11.2193 13.8333 13.8327 11.22 13.8327 7.99996C13.8327 4.77996 11.2193 2.16663 7.99352 2.16663ZM7.99935 12.6666C5.42102 12.6666 3.33268 10.5783 3.33268 7.99996C3.33268 5.42163 5.42102 3.33329 7.99935 3.33329C10.5777 3.33329 12.666 5.42163 12.666 7.99996C12.666 10.5783 10.5777 12.6666 7.99935 12.6666Z"
  }));
});